import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import { put, get } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic215 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromData, setFromData] = useState({
    interestPrevention: "",
    stakeholderConflictDisclosure: {
      disConflictsOfInterest: "",
      boardPositionsWithOtherOrganizations: "",
      crossShareholdingDisclosure: "",
      controllingShareholdersAndConflicts: "",
      relatedPartyTransactionsDisclosure: "",
    },
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = `This field is required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `This field is required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        setFromData({
          interestPrevention:
            res.data.data.GeneralDisclosures2021.conflictsOfInterest
              .interestPrevention,
          stakeholderConflictDisclosure: {
            disConflictsOfInterest:
              res.data.data.GeneralDisclosures2021.conflictsOfInterest
                .stakeholderConflictDisclosure.disConflictsOfInterest,
            boardPositionsWithOtherOrganizations:
              res.data.data.GeneralDisclosures2021.conflictsOfInterest
                .stakeholderConflictDisclosure
                .boardPositionsWithOtherOrganizations,
            crossShareholdingDisclosure:
              res.data.data.GeneralDisclosures2021.conflictsOfInterest
                .stakeholderConflictDisclosure.crossShareholdingDisclosure,
            controllingShareholdersAndConflicts:
              res.data.data.GeneralDisclosures2021.conflictsOfInterest
                .stakeholderConflictDisclosure
                .controllingShareholdersAndConflicts,
            relatedPartyTransactionsDisclosure:
              res.data.data.GeneralDisclosures2021.conflictsOfInterest
                .stakeholderConflictDisclosure
                .relatedPartyTransactionsDisclosure,
          },
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to handle form submission
  const handleSubmit = async () => {
    // const validationErrors = validateFields();

    // If there are errors, prevent form submission
    // if (Object.keys(validationErrors).length > 0) {
    //   console.log("Form contains errors", fromData, validationErrors);
    //   return;
    // }
    if (!disabled) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          conflictsOfInterest: { ...fromData },
          submitted2_15: true,

        });
        navigate(`/gri/general-disclosure/2-16/${id}`);
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-16/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "Describe the processes for the highest governance body to ensure that conflicts of interest are prevented and mitigated.",
      fieldName: "interestPrevention",
    },
    {
      index: "b.",
      heading:
        "Describe the process and frequency for senior executives or other employees to report back to the highest governance body on the management of the organization’s impacts on the economy, environment, and people.",
      subfieldName: "stakeholderConflictDisclosure",
      fieldName: "disConflictsOfInterest",
      fields: [
        {
          index: "i.",
          subheading:
            "Describe whether the organization report instances where members of the highest governance body also hold board positions with other organizations that may have business dealings with it's organization and how are the conflicts of interest is reported to stakeholders.",
          fieldName: "boardPositionsWithOtherOrganizations",
        },
        {
          index: "ii.",
          subheading:
            "Describe whether the organization disclose any significant cross-shareholding arrangements with suppliers, customers, or other stakeholders that could create potential conflicts and how are the conflicts of interest is reported to stakeholders.",
          fieldName: "crossShareholdingDisclosure",
        },
        {
          index: "iii.",
          subheading:
            "Describe whether there are any controlling shareholders in the organization, and how does the organization report on the nature of their control and potential conflicts arising from it. Report how are the conflicts of interest reported to stakeholders.",
          fieldName: "controllingShareholdersAndConflicts",
        },
        {
          index: "iv.",
          subheading:
            "Describe whether the organization disclose information about related parties (e.g., affiliates, subsidiaries), their relationships with the organization, any transactions conducted with them, and any outstanding balances owed to or from them?",
          fieldName: "relatedPartyTransactionsDisclosure",
        },
      ],
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <TextFieldData
        title="2-15 Conflicts of interest"
        {...{
          inputData,
          fromData,
          setFromData,
          setErrors,
          disabled: disabled,
          errors,
          hide,
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic215;
